import React from "react";
import { Button } from "./ui/button";
import { ArrowRight } from "lucide-react";

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1759302087504-4d92e36617fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBhd25pbmd8ZW58MHx8fHwxNzYxMDg1MzA5fDA&ixlib=rb-4.1.0&q=85"
          alt="Modern awning installation"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F]/95 via-[#0A192F]/85 to-[#0A192F]/70"></div>
      </div>

      <div className="relative z-10 container mx-auto px-4 py-32">
        <div className="max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-bold text-[#F2F2F2] mb-6 leading-tight">
            Somos especialistas en{" "}
            <span className="text-[#FFD700]">toldos y protecci&oacute;n solar</span>
          </h1>
          <p className="text-xl md:text-2xl text-[#F2F2F2]/90 mb-8 leading-relaxed">
            Somos una empresa con m&aacute;s de 30 a&ntilde;os de experiencia en el dise&ntilde;o, fabricaci&oacute;n e instalaci&oacute;n de toldos y sistemas de protecci&oacute;n solar. Nuestra herencia familiar nos ha permitido combinar la tradici&oacute;n artesanal con la innovaci&oacute;n tecnol&oacute;gica, ofreciendo soluciones duraderas, est&eacute;ticas y adaptadas a las necesidades de cada cliente.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Button
              onClick={() => scrollToSection("contacto")}
              className="bg-[#FFD700] text-[#0A192F] hover:bg-[#FFD700]/90 text-lg px-8 py-6 font-semibold group"
            >
              Solicitar presupuesto
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              onClick={() => scrollToSection("proyectos")}
              variant="outline"
              className="border-2 border-[#F2F2F2] text-[#F2F2F2] hover:bg-[#F2F2F2]/10 text-lg px-8 py-6 font-semibold"
            >
              Ver proyectos
            </Button>
          </div>
          <p className="text-[#F2F2F2]/80 text-lg">
            Soluciones personalizadas para viviendas, negocios y grandes superficies.
          </p>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0A192F] to-[#0A192F]/5 z-10"></div>
    </section>
  );
};

export default Hero;
